import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { RefreshButton, useAppBar } from "../../../components";
import { Breadcrumb, Family } from "../../../models";
import { useGetFamilyByIdQuery } from "../../../redux/apiStore";
import { getFamiliesBreadcrumb } from "../main";

export function getFamilyDetailBreadcrumb(family?: Family): Breadcrumb | null {
  if (!family) return null;
  return {
    title: family?.name,
    path: `/families/${family.id}`,
  };
}

export function FamilyDetailAppBarSetup() {
  const params = useParams();
  const familyId = parseInt(params.familyId || "");
  const appBar = useAppBar();
  const getFamilyById = useGetFamilyByIdQuery({ id: familyId });
  const family = getFamilyById.data;

  useEffect(() => {
    appBar.setDefaults();
    appBar.setTitle(family ? family.name : "Family Details");
    appBar.setBackUrl("/families");
    appBar.setBreadcrumbs([getFamiliesBreadcrumb(), getFamilyDetailBreadcrumb(family)].filter((x) => !!x));
    appBar.setRightContent(<RefreshButton onRefresh={() => getFamilyById.refetch()} />);
  }, [family]);

  return null;
}
